import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';

import './IconBanner.scss';
import classnames from 'classnames';

export function IconBanner({ theme, icon, textColor, bannerText }) {
	return (
		<div className={classnames('icon-banner', theme)}>
			<div className="icon">{icon}</div>
			<Text
				className="banner-text"
				color={textColor}
				size="smallMedium"
				last
			>
				{bannerText}
			</Text>
		</div>
	);
}

IconBanner.propTypes = {
	theme: PropTypes.oneOf(['orange']),
	icon: PropTypes.element,
	textColor: PropTypes.string,
	bannerText: PropTypes.string,
};

export default IconBanner;
